import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { unwrapResult } from "@reduxjs/toolkit";
import { selectLoading } from "src/modules/notification";
import GeneralDialog from "src/components/GeneralDialog";
import UpdateTransactionLimitDialogComponent from "./update-transaction-limit-dialog.component";
import { updateDisbursementInfo, updateTransactionLimit } from "../../../redux";

export default function UpdateTransactionLimitDialogContainer({
  selectedCompany,
  isOpen,
  handleClose,
  handleReload,
}) {
  const dispatch = useDispatch();
  const isSubmitting = useSelector((state) =>
    selectLoading(state, updateDisbursementInfo.typePrefix)
  );
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);

  const [disbursementInfo, setDisbursementInfo] = useState({
    value: "",
    remark: "",
    action: "credit",
  });

  const handleSubmit = (values) => {
    setDisbursementInfo({
      value: values.amount,
      remark: values.remark,
      action: values.limitUpdateAction,
    });
    setShowConfirmDialog(true);
  };

  const handleValidateBalance = (value, name, formik) => {
    if (value) {
      const regex = /^\d+$/;
      const isValid = regex.test(value);
      if (isValid) {
        formik.setFieldValue(name, value);
      }
    } else {
      formik.setFieldValue(name, value);
    }
  };

  const handleUpdateBalance = () => {
    setShowConfirmDialog(false);
    dispatch(
      updateTransactionLimit({
        id: selectedCompany.id,
        increase:
          disbursementInfo.action === "credit"
            ? 0
            : Number(disbursementInfo.value),
        decrease:
          disbursementInfo.action === "credit"
            ? Number(disbursementInfo.value)
            : 0,
        remark: disbursementInfo.remark,
      })
    )
      .then(unwrapResult)
      .then(() => {
        handleReload();
        handleClose();
      });
  };

  return (
    <>
      <UpdateTransactionLimitDialogComponent
        selectedCompany={selectedCompany}
        isOpen={isOpen}
        handleClose={handleClose}
        isSubmitting={isSubmitting}
        handleSubmit={handleSubmit}
        handleValidateBalance={handleValidateBalance}
      />
      <GeneralDialog
        isOpen={showConfirmDialog}
        handleClose={() => {
          setShowConfirmDialog(false);
        }}
        handleProceed={handleUpdateBalance}
        title="Confirm Update Transaction Limit"
        description="Are you sure want to update this company's transaction limit?"
        type="danger"
      />
    </>
  );
}
